define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerPbxAccountModel = /** @class */ (function () {
        function CustomerPbxAccountModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.Password = ko.observable();
            this.DisabledApp = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerPbxAccountModel.Mapping, self);
            }
        }
        CustomerPbxAccountModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerPbxAccountModel(options.data);
            }
        };
        return CustomerPbxAccountModel;
    }());
    return CustomerPbxAccountModel;
});
//# sourceMappingURL=CustomerPbxAccountModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerPbxAccountModel.js
// module id = 181
// module chunks = 2